export enum SetpointScheduleUnitEnum {
    Hour = 1,
    Day = 2,
    Week = 3,
    Month = 4,
    Year = 5
}